// extracted by mini-css-extract-plugin
module.exports = {"footer":"footerUnauthorized__footer__3Sg78"};